import crypto from 'crypto'

export const state = () => ({
  notifications: [],
  visibleNotifications: [],
  maxVisible: 5,
  delay: 5000,
  allowedTypes: ['error', 'warning', 'success'],
  defaultMessages: {
    success: 'La operación se ha completado con éxito',
    warning: 'Hay posibles problemas con la operación',
    error: 'Ha ocurrido un error, intente más tarde o contacte al administrador'
  }
})

export const getters = {
  notifications: (state) => state.notifications,
  visibleNotifications: (state) => state.visibleNotifications
}

export const mutations = {
  addNewNotification (state, notification) {
    state.notifications.push(notification)
  },
  removeNotification (state, id) {
    state.visibleNotifications = state.visibleNotifications.filter(n => n.id !== id)
  },
  removeAll (state) {
    state.notifications = []
    state.visibleNotifications = []
  },
  shiftNotification (state) {
    if (state.visibleNotifications.length < state.maxVisible && state.notifications.length > 0) {
      const next = state.notifications.shift()
      if (next) {
        state.visibleNotifications.push(next)
      }
    }
  }
}

export const actions = {
  addNewNotification ({ commit, dispatch, state }, notification = {}) {
    if (notification.type === 'danger') notification.type = 'error'
    const type = state.allowedTypes.includes(notification.type) ? notification.type : 'warning'
    const message = notification.message || state.defaultMessages[type]
    const autoClose = notification.autoClose !== undefined ? notification.autoClose : true

    const newItem = {
      id: crypto.randomBytes(16).toString('hex'),
      message,
      type,
      autoClose
    }

    commit('addNewNotification', newItem)
    dispatch('updateVisibleNotifications')
  },

  removeNotification ({ commit, dispatch }, id) {
    commit('removeNotification', id)
    dispatch('updateVisibleNotifications')
  },

  removeAllNotifications ({ commit }) {
    commit('removeAll')
  },

  async removeAllNotificationsOneByOne ({ state, dispatch }) {
    const delayBetween = 200
    for (const notification of [...state.visibleNotifications, ...state.notifications]) {
      await new Promise(resolve => {
        dispatch('removeNotification', notification.id)
        setTimeout(resolve, delayBetween)
      })
    }
  },

  updateVisibleNotifications ({ commit, state, dispatch }) {
    if (state.visibleNotifications.length < state.maxVisible && state.notifications.length > 0) {
      commit('shiftNotification')
      const next = state.visibleNotifications[state.visibleNotifications.length - 1]

      if (next && next.autoClose) {
        setTimeout(() => {
          dispatch('removeNotification', next.id)
          dispatch('updateVisibleNotifications')
        }, state.delay)
      }
    }
  }
}
